// extracted by mini-css-extract-plugin
export default {"agentWrapper":"ListingAgent_agentWrapper__l0P5l","icon":"ListingAgent_icon__574Cv"};